import React from 'react';
import { connect } from 'react-redux';

const HeaderNavItem = props => {
  const { screen, screenDescr, mainScreenPage, dispatch } = props;
  const itemStyle = {
    width: '116px',
    marginLeft: '15px',
    color: mainScreenPage === screen ? 'rgba(0,0,0,0.87)' : '#444',
    fontSize: '16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    background: mainScreenPage === screen ? '#ddd' : '#eee',
    transition: 'all 650ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
  }
  return (
    <div
      className='catalogPage'
      style={itemStyle}
      onClick={
        () => {
          dispatch({
            type: 'SET_MAIN_SCREEN_PAGE',
            p: screen
          })
        }
      }
    >
      {screenDescr}
      {mainScreenPage === screen &&
        <div style={{position: 'absolute', bottom: '0px', left: '0px', height: '3px', width: '100%', background: '#F44336'}}></div>
      }
    </div>
  );
}

export default connect(
  state => ({ mainScreenPage: state.ui.mainScreenPage })
)(HeaderNavItem);



// WEBPACK FOOTER //
// ./src/components/layout/header/nav/item.js